import styled from "styled-components";
import { HeaderSocialContainerProps } from "./HeaderSocial.types";

export const HeaderSocialContainer = styled.div<HeaderSocialContainerProps>`
  background-color: ${(props: { $backgroundcolor: string }) =>
    props.$backgroundcolor};

  .social__item{
    width: 76px;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (min-width: 992px) {
      display: none
    }

    .cmp-image{
      width:23px;

      .cmp-image__image {
        width:23px;
        height: 23px;
      }
    }
  
  }
`;
